import { Button } from "primereact/button";
import { Carousel } from "primereact/carousel";
import React from "react";

// Util
import { srcImagesFile } from "../../../utilities/FileUtil";

export default function P207PicList({ data, dialogDel, dialogUploadPic, disAddPicNewWork, viewImage }) {
    const actionBodyDel = (rowData) => dialogDel({ open: true, data: rowData });
    const actionBodyAddPic = () => dialogUploadPic({ dialog: true, show: true });

    const carouselResponsiveOptions = [
        {
            breakpoint: "1024px",
            numVisible: 3,
            numScroll: 3,
        },
        {
            breakpoint: "768px",
            numVisible: 2,
            numScroll: 2,
        },
        {
            breakpoint: "560px",
            numVisible: 1,
            numScroll: 1,
        },
    ];

    const carouselItemTemplate = (data) => {
        return (
            <div className="product-item">
                <div className="product-item-content">
                    <div className="p-mb-3">
                        <img
                            {...srcImagesFile(data.photoPath)}
                            alt={data.inspectorName}
                            //className="product-image"
                            style={{ width: 100, height: 80, cursor: "pointer" }}
                            onClick={() => viewImage(data.photoPath)}
                        />
                    </div>
                    <div>
                        <br />
                        <Button type="button" className="p-button-danger p-button" icon="pi pi-trash" onClick={() => actionBodyDel(data)} disabled={disAddPicNewWork()}></Button>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div>
            <div className="p-grid p-fluid media-demo">
                <div className="p-col-12">
                    <div className="card">
                        <div className="p-col-12">
                            <Carousel value={data} numVisible={4} numScroll={3} responsiveOptions={carouselResponsiveOptions} itemTemplate={carouselItemTemplate}></Carousel>
                        </div>
                        <div className="p-col-12" style={{ textAlign: "center" }}>
                            <Button
                                className="p-button p-button-success"
                                icon="pi pi-image"
                                label="เพิ่มรูปถ่าย"
                                // style={{ marginLeft: '5px' }}
                                style={{ width: 120, marginLeft: "5px", marginTop: "10px" }}
                                onClick={() => actionBodyAddPic()}
                                disabled={disAddPicNewWork()}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
